// TODO merge this with ClaimsZoom
import React from 'react'
import { connect } from 'react-redux'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import { setOpenedSubmenu, setBrNr, fetchClientOptionsDict, fetchClientContract, navigateToConnexClaim, getClaimDetail } from 'state/actions'
import styles from './clientClaimsZoom.scss'
import Uploader from '../uploader'
import KeyValue from '../KeyValue'
import { formatDate, getTheLanguageCodeByAnyLanguageOnAnyLanguage, findContractIdByContractNumber, generateClientDicts } from 'lib/helpers'
import EmailButton from '../emailSender/emailButton'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
import c from 'state/constants'
import MifidButton from '../DSDocuments/mifidButton'
import ClaimWizardButton from '../ClaimsWizard/ClaimWizardButton'

const _ = i18n('claimsZoom')

@connect((state, props) => ({
    EmailTemplateRelations: state.app.security.EmailTemplateRelations,
    clientAccess: state.app.security.actions,
    brNr: state.app.brNr,
    clientData: props && props.clientData || {},
    clientId: props && props.clientId || '',
    clientOptionsDict: state.client.clientOptionsDict,
    contractManagerMail: state.contracts.contractManagerMail,
    appLanguage: state.app.lang,
    contracts: state.contracts,
    claimDetail: nesProp.get(state, "client.claimDetail"),
    selectedTicketDocuments: nesProp.get(state, "clients.initialArguments.selectedTicketDocuments"),
    ticketDocuments: nesProp.get(state, "clients.initialArguments.ticketDocuments"),
    ticketId: nesProp.get(state, "clients.initialArguments.ticketId"),
    emailAttachmentTicketDocuments: nesProp.get(state, "clients.initialArguments.emailAttachmentTicketDocuments"),

}))

export default class ClientClaimsZoom extends React.Component {
    static propTypes = {
        clientData: React.PropTypes.object,
        clientId: React.PropTypes.string,
        claim: React.PropTypes.object.isRequired,
        claimMoreDetails: React.PropTypes.object,
        initializationCompleted: React.PropTypes.bool,
        clientOptionsDict: React.PropTypes.object,
        zoomTo: React.PropTypes.func
    }

    /**
     * Fetching clientContracts and clientClaims data from server and set it for usage.
     */
    fetchData() {
        const { dispatch } = this.props

        // using the current claim broker number
        if (/* !brNr && */ contractBrokerNumber) {
            dispatch(setBrNr(contractBrokerNumber))
        }
    }

    /**
     * Constructor: initialize state etc.
     * @param {*} props
     */
    constructor(props) {
        super(props)
        let { clientOptionsDict, appLanguage } = props
        this.state = { clientOptionsDict, claimDetailLoaded: false, extendedClientOptionsDict: generateClientDicts(clientOptionsDict, appLanguage) }
    }

    /**
     * This function will trigger when component did mounted
     */
    componentDidMount() {
        const { dispatch, clientOptionsDict, claim, contracts } = this.props
        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
                .then((dictionary) => {
                    this.setClientOptionsDict(dictionary)
                })
        } else {
            if (!this.state.clientOptionsDict) {
                this.setClientOptionsDict(clientOptionsDict)
            }
        }
        let claimContractNumber = claim.claimMain.contractNumber

        let contractId = findContractIdByContractNumber(contracts, claimContractNumber)
        if (contractId) {
            this.setState({ contractId });
            // get client contract, and the reducer insert the contractManagerMail in to the store
            dispatch(fetchClientContract(contractId))
        }
    }

    /**
     * Set client options dict in to the state
     * @param {object} dictionary - contains the dictionary
     */
    setClientOptionsDict(dictionary) {
        this.setState({ clientOptionsDict: dictionary }, () => {
            this.forceUpdate()
        })
    }



    /**
     * Event for close claim. Back to list.
     */
    handleClose = () => {
        const { dispatch } = this.props
        dispatch(setOpenedSubmenu(''))
    }

    componentWillUnmount() {
        this.handleClose()
    }

    /**
     * The update function of module, fired when props or state updated
     * @param {*} nextProp
     * @param {*} nextState
     */
    componentWillUpdate(nextProp, nextState) {
        const { dispatch } = this.props

        let claimContractNumber = nesProp.get(nextProp, "claim.claimMain.contractNumber")
        let contracts = nesProp.get(nextProp, "contracts")
        let contractId = findContractIdByContractNumber(contracts, claimContractNumber)

        // when we have the step when related api calls are finished and got the results
        if (!nextProp.contractManagerMail && nextProp.contracts && nextProp.claim) {
            if (contractId) {
                // get client contract, and the reducer insert the contractManagerMail in to the store
                dispatch(fetchClientContract(contractId))
            }
        }
    }

    /**
     * This function return with values for email sender, collected from this module
     * depending on the current data structure.
     */
    collectVariableValues() {
        const { clientData, clientId, claimMoreDetails, claimDetail, claim, contracts } = this.props
        const { clientOptionsDict } = this.state

        // digging out the contract related documents
        let claimContractNumber = nesProp.get(claim, "claimMain.contractNumber")
        let contractId = findContractIdByContractNumber(contracts, claimContractNumber)
        const contract = nesProp.get(contracts, contractId)
        const contractDocuments = nesProp.get(contract, "documents")
        const contractDocumentsId = contractId

        let contractBrokerNumber = nesProp.get(claim, "claimMain.brokerNumber") || nesProp.get(claimMoreDetails, "main.brokerNumber")
        let emails = nesProp.get(clientData, "detail.emails")
        let clientName = nesProp.get(clientData, "main.name")

        // process email list to be digestible for email sender
        emails = emails.map((item) => ({
            referenceId: clientId,
            label: clientName,
            value: item.email,
            default: (item.default == "true" || item.default == true) ? true : false
        }))

        emails = emails.sort((item, item2) => {
            if (item.default && !item2.default) { return -1 }
            if (!item.default && item2.default) { return 1 }
            if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
        }) || []

        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguage = nesProp.get(clientData, "detail.language") || ''
        clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, clientOptionsDict)

        return {
            contractNumber: nesProp.get(this.props, "claim.claimMain.contractNumber"),
            claimsNumber: nesProp.get(this.props, "claim.claimMain.claimNumber"),

            clientDocuments: nesProp.get(clientData, "clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            // new v6 mode
            claimDocuments: nesProp.get(this.props, "claim.claimDocuments"),
            claimDocumentsType: "claim",
            claimDocumentsId: nesProp.get(this.props, "claim.claimMain.claimId"),

            contractDocuments: contractDocuments,
            contractDocumentsType: "contract",
            contractDocumentsId: contractDocumentsId,
            companyCancelMail: contract.companyCancelMail,

            clientId: false,
            contractId: false,
            claimId: nesProp.get(this.props, "claim.claimMain.claimId"),
            company: nesProp.get(this.props, "claim.claimDetails.insuranceCompany"),
            clientName: clientName,
            clientNumber: nesProp.get(clientData, "main.clientNumber"),
            clientLanguage,
            clientEmails: emails,

            brokerNumber: contractBrokerNumber,

            claim: nesProp.get(this.props, "claim"),
            claimDetail,
            clientData: nesProp.get(clientData, "main")
        }
    }

    /**
     * This function render the data for the qualification column in the claims result table.
     * @param {object} main - thi is the claims record main property, what contains the qualification values
     */
    formatQualification(qualification, subQualification) {
        return (
            <span>
                <span>
                    {qualification}
                </span>
                {subQualification &&
                    <span>
                        ,<br />
                        {subQualification}
                    </span>
                }
            </span>)
    }

    zoomTo(claimNumber) {
        const { dispatch } = this.props
        return dispatch(navigateToConnexClaim(c.CLAIMS, claimNumber))
    }

    /**
    * Resets ticket data from store in order to prevent multiple additions to dsWizzard
    */
    resetDataFromStoreOnCancel() {
        const { dispatch, ticketId, claimId } = this.props

        //reset aditional data fro tickets
        if (ticketId) {
            dispatch(setOpenedSubmenu(claimId, {}))
        }
    }

    render() {
        const { claim, clientAccess, initializationCompleted, clientId, ticketId, ticketDocuments, selectedTicketDocuments, emailAttachmentTicketDocuments, dispatch } = this.props
        const createMail = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0

        const canCreateMifid = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmifid" && item.actionAllowed == "true")).length > 0

        const { clientOptionsDict, contractId, extendedClientOptionsDict } = this.state

        if (!claim || !clientOptionsDict) { return <span>...</span> }

        const {
            claimMain: {
                claimId, claimDate, claimNumber, state,
                contractNumber, claimsManagerName, creationDate, qualification,
                subQualification, brokerNumber
            },
            claimDetails: { insuranceCompany, riskDescription, branche },
            claimDocuments
        } = claim
        const { claimDetail: claimDetailsFromProps } = this.props
        const { claimRefBroker } = claimDetailsFromProps
        
        const columns = [
            [
                { label: _('insuranceCompany'), value: insuranceCompany || '' },
                { label: _('claimDate'), value: formatDate(claimDate) || '' },
                { label: _('state'), value: state || '' },
                { label: _('contractNumber'), value: contractNumber || '' },
                { label: _('riskDescription'), value: riskDescription || '' },
                { label: _('claimRefBroker'), value: claimRefBroker || ''}
            ],
            [
                { label: _('claimsManager'), value: claimsManagerName || '' },
                { label: _('creationDate'), value: formatDate(creationDate) || '' },
                { label: _('qualification'), value: this.formatQualification(qualification, subQualification) || '' },
                { label: _('branche'), value: branche || '' },
            ],
        ]
        const moduleKeyToSet = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value") || false
        
        const involvedPartiesLabels = claimDetailsFromProps.missingInfo.involvedParties.map(value => {
            const involvedTexts = extendedClientOptionsDict.involvedParties.find(option => option.value === value)
            return involvedTexts ? involvedTexts.label : ''
        })

        const missingDocumentsLabels = []

        for (const oneDoc of claimDetailsFromProps.missingInfo.documents) {
            if (claimDetailsFromProps.Documents && claimDetailsFromProps.Documents.length > 0) {
                const missingDocType = claimDetailsFromProps.Documents.find(doc => doc.docType === oneDoc.docType);
                if (missingDocType) {
                    if (missingDocType.alternativeDocTypes && missingDocType.alternativeDocTypes.length > 0) {
                        const selectedAlternative = missingDocType.alternativeDocTypes.find(altDoc => +altDoc.altDocCount > 0);
                        if (selectedAlternative) {
                            missingDocType.alternativeDocTypes
                                .filter(altDoc => +altDoc.altDocCount === 0 && altDoc.alternativeNr === selectedAlternative.alternativeNr)
                                .forEach(altDoc => {
                                    const newLabel = extendedClientOptionsDict.documentTypeOptions.find(option => option.value === altDoc.altDocType);
                                    if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
                                        missingDocumentsLabels.push(newLabel);
                                    }
                                });
                        } else {
                            const newLabel = extendedClientOptionsDict.documentTypeOptions.find(option => option.value === oneDoc.docType);
                            if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
                                missingDocumentsLabels.push(newLabel);
                            }
                        }
                    } else if (missingDocType.docCount && +missingDocType.docCount <= 0) {
                        const newLabel = extendedClientOptionsDict.documentTypeOptions.find(option => option.value === oneDoc.docType);
                        if (newLabel && !missingDocumentsLabels.includes(newLabel)) {
                            missingDocumentsLabels.push(newLabel);
                        }
                    }
                }
            }
        }

        const claimStatusAndQualification = {}
        if (claimDetailsFromProps) {
            claimStatusAndQualification.claimStatus = claimDetailsFromProps.claimStatus
            claimStatusAndQualification.qualificationNumber = claimDetailsFromProps.qualificationNumber
            claimStatusAndQualification.subQualificationNumber = claimDetailsFromProps.subQualificationNumber
        }
        
        return (
            <div className={styles.clientClaimsZoomContainer}>
                <div className={styles.mainTitleDiv}>
                    <div className={styles.moduleControls}>
                        <div className={styles.buttonOrganizer}>
                            <div onClick={this.handleClose} className={`${styles.backToList}`}>{_('backToList')}</div>

                            {createMail && initializationCompleted &&
                                <EmailButton moduleKeyToSet={moduleKeyToSet} moduleOptions={this.collectVariableValues()} />}
                            {canCreateMifid && <div className={styles.DSWizardButtonWrapper}>
                                <MifidButton
                                    moduleKeyToSet={c.DS_MODULE_CLIENT_CLAIMS}
                                    subModuleKeyToSet={c.DS_MODULE_CLIENT_CLAIMS}
                                    clientId={clientId}
                                    claimId={claimId}
                                    claimNumber={claimNumber}
                                    callBackOnClose={() => this.resetDataFromStoreOnCancel()}
                                    moduleOptions={this.collectVariableValues()}
                                    ticketId={ticketId}
                                    ticketDocuments={ticketDocuments}
                                    selectedTicketDocuments={selectedTicketDocuments}
                                    emailAttachmentTicketDocuments={emailAttachmentTicketDocuments}
                                />
                            </div>
                            }
                            {claimDetailsFromProps.claimStatus === '8' && <div>
                                <div className={styles.wizardButtonCorrection} >
                                    <ClaimWizardButton
                                        contractId={contractId}
                                        claimNumber={claimNumber}
                                        claimData={claimDetailsFromProps}
                                        clientId={claimDetailsFromProps.client.clientId}
                                        brokerNumber={brokerNumber}
                                        onCloseMethod={() => this.props.dispatch(getClaimDetail(claimId))}
                                        onGoing
                                    />
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className={styles.clientClaimsZoom}>
                    <div className={styles.moduleSection}>
                        <div className={styles.moduleSectionHeading}>
                            <h2 className={styles.subTitle}>
                                {_('claimNumber')} <span>{claimNumber}</span>
                            </h2>
                        </div>
                        <KeyValue array={columns} divider />
                    </div>
                    {(involvedPartiesLabels.length > 0 || missingDocumentsLabels.length > 0) && <div className={styles.moduleSection}>
                        <div className={styles.moduleSectionHeading}>
                            <h2 className={styles.subTitle}>
                                {_('missingInfo')}
                            </h2>
                        </div>
                        <div className={styles.missingInfo}>
                            {involvedPartiesLabels.length > 0 && <div className={styles.missingInfoColumn}>
                                <span className={styles.missingInfoTitle}>{_('missingInvolvedParties')}:</span>
                                <div className={styles.missingInfoEnum}>
                                    {involvedPartiesLabels.map((label, index) => (
                                        <span key={index} className={styles.missingInfoRow}>{label}</span>
                                    ))}
                                </div>
                            </div>}
                            {missingDocumentsLabels.length > 0 && <div className={styles.missingInfoColumn}>
                                <span className={styles.missingInfoTitle}>{_('missingDocuments')}:</span>
                                <div className={styles.missingInfoEnum}>
                                    {missingDocumentsLabels.map((label, index) => (
                                        <span key={index} className={styles.missingInfoRow}>{label.label}</span>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>}
                    <div className={styles.moduleSection}>
                        <div className={styles.moduleSectionHeading}>
                            <h2 className={styles.subTitle}>
                                {_('connex')}
                            </h2>
                        </div>
                        <Table
                            className={styles.table}
                            itemsPerPage={20}
                        >
                            <Thead>
                                <Th column="claimNumber">
                                    <strong>{_('claimNumber')}</strong>
                                </Th>
                                <Th column="nameClient">
                                    <strong>{_('nameClient')}</strong>
                                </Th>
                                <Th column="contractNumber">
                                    <strong>{_('contractNumber')}</strong>
                                </Th>
                                <Th column="companyName">
                                    <strong>{_('companyName')}</strong>
                                </Th>
                                <Th column="qualification">
                                    <strong>{_('qualification')}</strong>
                                </Th>
                                <Th column="state">
                                    <strong>{_('state')}</strong>
                                </Th>
                            </Thead>
                            {claim.connex.map((item, key) =>
                                <Tr
                                    className="clickable centered"
                                    onClick={() => this.zoomTo(item.claimNumber)} key={key}
                                >
                                    <Td column="claimNumber">{item.claimNumber}</Td>
                                    <Td column="nameClient">{item.clientName}</Td>
                                    <Td column="contractNumber">{item.contractNumber}</Td>
                                    <Td column="companyName">{item.companyName}</Td>
                                    <Td column="qualification">{item.qualification}</Td>
                                    <Td column="state">{item.state}</Td>
                                </Tr>
                            )
                            }
                        </Table>
                    </div>
                    <Uploader
                        type="claim"
                        documents={claimDocuments}
                        id={claimId}
                        claimStatusAndQualification={claimStatusAndQualification}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientClaimsZoom.jsx